import removeIeFormElement from '../util/removeIeFormElement';
import ScheduleAConsultationForm from '../svelte/ScheduleAConsultationForm.svelte';

export default {
  init() {
    // remove IE Schedule A Consultation form
    removeIeFormElement('#consultation-form-ie');

    // for accessing localized variables from PHP
    const sanctum = window.sanctum;

    // instantiate Svelte component
    new ScheduleAConsultationForm({
      target: document.querySelector('#schedule-consultation-form'),
      props: {
        // account, campaign prefix, & company are used in LoanForce API call to create contact
        account: sanctum.account,
        loanforceId: sanctum.loanforce_id,
        campaignPrefix: sanctum.campaign_prefix,
        sourceName: sanctum.source_name,
        // company name displayed in disclaimer text below form
        company: sanctum.company,
        // use brand button color or not? parseInt to use truthy/falsy value
        brandButtonColor: parseInt(sanctum.brand_button_color),
      },
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/scheduleConsultation.js